<template>
  <div>
    <el-page-header class="detail-head" @back="goBack">
      <template v-slot:content>
        <div class="toolbar">
          <span>收费单详情</span>
          <div class="toolbar-items">
            <el-button size="mini" type="success" @click="audit">审核通过</el-button>
          </div>
        </div>
      </template>
    </el-page-header>
    <el-divider class="detail-divider"></el-divider>
    <el-tabs>
      <el-tab-pane label="基本信息">
        <div class="detail-containe-product">
          <el-scrollbar>
            <el-form class="detail-form" ref="mainForm" :model="entity" :rules="rules" label-width="100px">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="收费单号" class="detail-form-item" prop="code">
                      <el-input size="medium" v-model="entity.code"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="收费单名称" class="detail-form-item" prop="name">
                      <el-input size="medium" v-model="entity.name"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="送检订单号" class="detail-form-item">
                      <el-input size="medium" v-model="entity.inspect.code" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="委托单号" class="detail-form-item">
                      <el-input size="medium" v-model="entity.delegateCodes" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="总费用" class="detail-form-item">
                      <el-input size="medium" v-model="entity.totalMoney" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="检测费用" class="detail-form-item">
                      <el-input size="medium" v-model="entity.testMoney" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="服务费用" class="detail-form-item">
                      <el-input size="medium" v-model="entity.serviceMoney" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="返货运费" class="detail-form-item">
                      <el-input size="medium" v-model="entity.freightMoney" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="状态" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.state">
                        <el-option v-for="item in states" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="收款单位名称" class="detail-form-item">
                      <el-input size="medium" v-model="entity.companyName"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="收款开户银行" class="detail-form-item">
                      <el-input size="medium" v-model="entity.bank"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="收款银行账号" class="detail-form-item">
                      <el-input size="medium" v-model="entity.bankAccount"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="联系人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.person"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="联系电话" class="detail-form-item">
                      <el-input size="medium" v-model="entity.phone"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="邮箱" class="detail-form-item">
                      <el-input size="medium" v-model="entity.email"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.creator" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.createTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifier" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifyTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <div class="grid-content">
                    <el-form-item label="备注" class="detail-form-item">
                      <el-input type="textarea" v-model="entity.remark"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="收费详情列表">
        <el-form class="detail-form2" ref="mainForm2" :model="entity" :rules="rules" label-width="70px">
          <el-row :gutter="20">
            <el-col :span="3">
              <div class="grid-content">
                <el-form-item label="检测费用" class="detail-form-item">
                  <el-input size="small" v-model="entity.testMoney" readonly></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content">
                <el-form-item label="服务费用" class="detail-form-item">
                  <el-input size="small" v-model="entity.serviceMoney" readonly></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content">
                <el-form-item label="返货运费" class="detail-form-item">
                  <el-input size="small" v-model="entity.freightMoney"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content">
                <el-form-item label="总费用" class="detail-form-item">
                  <el-input size="small" v-model="entity.totalMoney" readonly></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content">
                <el-form-item label="操作：" class="detail-form-item">
                  <el-button size="small" type="danger" @click="calculateSum">重新计算总费用</el-button>
                  <el-button size="small" type="primary" @click="merge">合并</el-button>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <el-alert class="error-alert" v-if="change" title="您已调整服务费用，请在调整完成后，点击[重新计算总费用]。" type="warning" />
        <el-alert class="error-alert" v-if="error" title="验证提示：" type="error" :description="error" show-icon />
        <el-table ref="tableCharge" class="table-charge" :data="entity.chargeDetails" border style="width: 100%;" height="calc(100vh - 400px)" stripe @row-click="rowClick" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="no" label="序号" width="50"> </el-table-column>
          <el-table-column prop="inspectDetail.name" label="仪器名称" width="300"> </el-table-column>
          <el-table-column prop="inspectDetail.model" label="仪器型号" width="150"> </el-table-column>
          <el-table-column prop="inspectDetail.factoryNumber" label="出厂编号" width="200">
            <template #default="scope">
              <div class="column-tag">
                <span>{{ scope.row.quantity>1?scope.row.factoryNumbers:scope.row.inspectDetail.factoryNumber }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="quantity" label="数量" width="120"> </el-table-column>
          <el-table-column label="超高超重" width="100">
            <template #default="scope">
              <div class="column-tag" v-if="scope.row.edit">
                <el-checkbox class="item-edit" size="mini" v-model="scope.row.exceed" @change="exceedChange(scope.row)"></el-checkbox>
              </div>
              <div class="column-tag" v-else>
                <el-tag v-if="scope.row.exceed" type="danger" size="mini">{{ scope.row.exceed?"是":"否" }}</el-tag>
                <el-tag v-else size="mini">{{ scope.row.exceed?"是":"否" }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="检测结果" width="100">
            <template #default="scope">
              <div class="column-tag">
                <el-tag v-if="scope.row.state==='1'" size="mini">{{ scope.row.state==='1'?"检测完成":"退检" }}</el-tag>
                <el-tag v-if="scope.row.state==='2'" type="danger" size="mini">{{ scope.row.state==='1'?"检测完成":"退检" }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="是否强检" width="80">
            <template #default="scope">
              <div class="column-tag">
                <el-tag v-if="scope.row.delegateSub.isForce" type="danger" size="mini">{{ scope.row.delegateSub.isForce?"是":"否" }}</el-tag>
                <el-tag v-else size="mini">{{ scope.row.delegateSub.isForce?"是":"否" }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="计算类型" width="120">
            <template #default="scope">
              <div v-if="scope.row.edit">
                <el-select v-model="scope.row.type" size="mini">
                  <el-option label="自动计算" value="1"></el-option>
                  <el-option label="自定义录入" value="2"></el-option>
                </el-select>
              </div>
              <div v-else class="column-tag">
                <el-tag v-if="scope.row.type==='1'" size="mini">{{ scope.row.type==='1'?"自动计算":"自定义录入" }}</el-tag>
                <el-tag v-if="scope.row.type==='2'" type="danger" size="mini">{{ scope.row.type==='1'?"自动计算":"自定义录入" }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="actualTestMoney" label="检测费用" width="80"> </el-table-column>
          <el-table-column label="服务费用" width="100">
            <template #default="scope">
              <div v-if="scope.row.edit">
                <input v-if="scope.row.type==='2'" v-model.lazy="scope.row.serviceMoney" class="el-input__inner input-row-edit" @input="serviceMoneyInput(scope.row)" />
                <span v-else>{{scope.row.serviceMoney}}</span>
              </div>
              <div v-else>
                {{scope.row.serviceMoney}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="备注">
            <template #default="scope">
              <div v-if="scope.row.edit">
                <input v-model.lazy="scope.row.remark" class="el-input__inner input-row-edit" />
              </div>
              <div v-else>
                {{scope.row.remark}}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import {
  Charge,
  ChargeDetailEntity,
} from "@/script/apps/inspect/entity/InspectEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { ChargeService } from "@/script/apps/inspect/service/ChargeService";
import { ElMessage, ElMessageBox } from "element-plus";

@Options({})
export default class ChargeDetail extends BaseDetail {
  private service = new ChargeService();

  protected selectedList: ChargeDetailEntity[] = [];

  private change = false;

  private error: string | null = null;

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_ins_charge",
      "/ins/charge",
      "/ins/charge",
      this.service
    );
    data.entity = {
      inspect: { code: "", name: "" },
    };
    data.statesName = "ins-charge-state";
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入收费单号", trigger: "blur" }],
    name: [{ required: true, message: "请输入收费单名称", trigger: "blur" }],
  };

  public newEntity() {
    const entity: Charge = {};
    return entity;
  }

  public afterLoad() {
    this.change = false;
    const charge = this.entity as Charge;
    charge.deleteChargeDetails = [];
    this.injectDetailData(charge.chargeDetails!, charge.deleteChargeDetails);
    this.generateRowNo();
  }

  private audit() {
    const charge = this.entity as Charge;
    if (charge.chargeDetails) {
      const errors: string[] = [];
      charge.chargeDetails.forEach((item) => {
        if (item.type === "2") {
          const value =
            item.serviceMoney!.toString().replace(/\D/g, "") === ""
              ? 0
              : item.serviceMoney!;
          if (value <= 0) {
            errors.push(`第 [${item.no}] 行的 [服务费用] 不能为0！`);
          }
        }
      });

      if (errors.length > 0) {
        this.error = errors.join("");
        ElMessage.error(`审核失败!`);
        return false;
      } else {
        this.error = null;
      }
    }

    ElMessageBox.confirm("此操作将[审核订单], 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        this.service.audit(
          charge,
          (data: any) => {
            ElMessage({ type: "success", message: data.message });
            this.load(this.id);
          },
          function (error: Error) {
            ElMessage.error(error.message);
          }
        );
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消操作",
        });
      });
  }

  calculateSum() {
    const charge = this.entity as Charge;
    this.service.calculateSum(charge, (result: Charge) => {
      charge.testMoney = result.testMoney;
      charge.serviceMoney = result.serviceMoney;
      charge.totalMoney = result.totalMoney;
      this.change = false;
      ElMessage.success("计算完成");
    });
  }

  handleSelectionChange(val: any) {
    this.selectedList = val;
  }

  exceedChange(data: ChargeDetailEntity) {
    this.service.calculateItem(data, (result: ChargeDetailEntity) => {
      data.actualTestMoney = result.actualTestMoney;
      data.serviceMoney = result.serviceMoney;
      data.flag = "M";
      this.change = true;
      ElMessage.success("重新计算完成");
    });
  }

  serviceMoneyInput(data: ChargeDetailEntity) {
    this.change = true;
  }

  merge() {
    if (this.selectedList.length === 0) {
      ElMessage.error("请选择要合并的数据行！");
      return;
    }
    if (this.selectedList.length === 1) {
      ElMessage.error("不能选择1行数据合并！");
      return;
    }
    const firstName = this.selectedList[0].inspectDetail!.name;
    const firstPlanTestMoney = this.selectedList[0].planTestMoney;

    let check = true;
    this.selectedList.forEach((item) => {
      if (item.inspectDetail!.name !== firstName) {
        ElMessage.error("仪器名称不一致，不能合并！");
        check = false;
        return false;
      }
      if (item.planTestMoney !== firstPlanTestMoney) {
        ElMessage.error("检测费用不一致，不能合并！");
        check = false;
        return false;
      }
    });
    if (!check) {
      return;
    }

    const firstDetail = this.selectedList[0];
    const firstId = firstDetail.id;
    let factoryNumbers = firstDetail.factoryNumbers
      ? firstDetail.factoryNumbers
      : "";
    this.selectedList.forEach((item) => {
      factoryNumbers += "," + item.inspectDetail?.factoryNumber;
      if (item.id !== firstId) {
        firstDetail.quantity = firstDetail.quantity! + item.quantity!;
        item.flag = "D";
        this.deleteRowList.push(item);
      }
    });

    this.service.calculateItem(firstDetail, (result: ChargeDetailEntity) => {
      firstDetail.actualTestMoney = result.actualTestMoney;
      firstDetail.serviceMoney = result.serviceMoney;
      firstDetail.factoryNumbers = factoryNumbers.substring(1);
      firstDetail.flag = "M";

      const charge = this.entity as Charge;
      const newList: ChargeDetailEntity[] = [];
      charge.chargeDetails!.forEach((item) => {
        if (item.flag !== "D") {
          newList.push(item);
        }
      });
      charge.chargeDetails = newList;
      this.rowList = charge.chargeDetails;
      super.generateRowNo();
      (this.$refs.tableCharge as any).clearSelection();
      ElMessage.success("合并完成");
    });
  }
}
</script>

<style lang="scss">
.table-charge {
  margin-top: 20px;
}
.item-edit {
  height: 18px !important;
}

.item-edit-number {
  width: 100px !important;
}

.input-row-edit {
  height: 28px !important;
}

.error-alert {
  margin-top: 20px !important;
}

.el-checkbox {
  height: 24px !important;
}
</style>
